const VerifoneAuthHandler = require('@/lib/PaymentMethods/Verifone/VerifoneAuthHandler');
const VerifoneConfig = require('@/lib/PaymentMethods/Verifone/VerifoneConfig');
const VerifoneDriver = require('@/lib/PaymentMethods/Verifone/VerifoneDriver');
const VerifoneResponseRecordFactory = require('@/lib/PaymentMethods/Verifone/VerifoneResponseRecordFactory');

app.factory(
    'verifoneConfig',
    /**
     * @param hydrator
     * @param {CurrentDevice} currentDevice
     * @param {PaymentMethodService} paymentMethodService
     * @param {UserService} userService
     */
    function (
        hydrator,
        currentDevice,
        paymentMethodService,
        userService
    ) {
        let config = new VerifoneConfig();

        let paymentMethod = paymentMethodService.getByRef('card-verifone-chip-and-pin');
        if (!paymentMethod) {
            throw new Error('Company does not have Verifone payment method enabled.');
        }

        // Set config from the company's payment method config.
        if (paymentMethod.config) {
            let companyTerminalConfig = JSON.parse(paymentMethod.config);
            hydrator.hydrate(companyTerminalConfig, config);
        }

        // Set config from the device's payment method config.
        let device = currentDevice.device;
        if (device.paymentTerminalConfig) {
            if (device.paymentTerminalConfig.hasOwnProperty('card-verifone-chip-and-pin')) {
                hydrator.hydrate(device.paymentTerminalConfig['card-verifone-chip-and-pin'], config);
            }
        }

        // Set config from the user's payment method config.
        if (userService.paymentTerminalConfig) {
            if (userService.paymentTerminalConfig.hasOwnProperty('card-verifone-chip-and-pin')) {
                hydrator.hydrate(userService.paymentTerminalConfig['card-verifone-chip-and-pin'], config);
            }
        }

        console.log('[VerifoneConfig]', config);

        return config;
    }
);

app.service('verifoneAuthHandler', VerifoneAuthHandler);
app.service('verifoneDriver', VerifoneDriver);
app.service('verifoneResponseRecordFactory', VerifoneResponseRecordFactory);
